import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from "@mui/material";
import { useNavigate } from "react-router-dom";
export interface SimpleDialogProps {
  open:boolean
  setOpen:(x: boolean)=>void
  messagetype:string
}

const SimpleDialog = (props: SimpleDialogProps) => {

  const { open, setOpen, messagetype } = props;

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSuccess = () => {
    setOpen(false);
    navigate("/form/list");
  }
  
  const handleCloseDelete = () => {
    setOpen(false);
    window.location.reload();
  }

  return (
    
    <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
        "& .MuiDialog-container": {
            "& .MuiPaper-root": {
            width: "100%",
            maxWidth: messagetype==="successedit" || messagetype==="successdelete"? "500px" : "800px",  // Set your width here
            },
        },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {"Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messagetype === "express" && <>
            Express test service will be evaluated by the laboratory and is not promised to be accepted. <br></br>
            Express test service charge depend on laboratory and customer completion date of agreement. <br></br><br></br>
            實驗室會評估能否提供快速測試服務。根據情況，實驗室有可能無法提供快速測試服務。 <br></br>
            快速測試服務費用取決於實驗室與客戶協議測試完成日期。 <br></br></>}
            {messagetype === "success" && <>
            Your test request form has been submitted. Please contact Winky Yiu at 2597 8273 for sample delivery arrangement. <br></br>
            你的申請已經送出。請致電2597 8273與Winky Yiu安排收鐵。<br></br></>}
            {messagetype === "successedit" && <>
            Edit Succeed. <br></br>
            成功修改。<br></br></>}
            {messagetype === "successsave" && <>
            The form is sucessfully saved. You can continue fuilling the form, or leave this page and continue filling later. <br></br>
            成功儲存表格。你可以繼續填寫表格，或者暫時離開此頁面，之後再繼續填寫。
            <br></br></>}
            {messagetype === "successdelete" && <>
            Delete Succeed. <br></br>
            刪除成功。<br></br></>}
          </DialogContentText>
          <DialogActions>
          <Button variant="contained" onClick={
            ()=> {
              switch (messagetype)
              {
                case "express":
                case "successsave":
                  handleClose()
                  return
                case "successdelete":
                  handleCloseDelete()
                  return
                default:
                  handleCloseSuccess()
              }
            }}>Close</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
  );
};

export default SimpleDialog;
